var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-overlay',{attrs:{"opacity":"0.2","absolute":_vm.absolute,"z-index":_vm.zIndex}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":'var(--v-primary-base)',"size":_vm.size}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }